import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import { Form, Button, FieldRadioButton, ModalPortal } from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import css from './ContactPreferenceModal.css';
import { updateUserProfileInfo } from '../../ducks/user.duck';
import { useRequest } from '../../hooks/useRequest';
import { contactOptions } from '../../contactOptions-config';

const ContactPreferenceModal = ({ isOpen, onClose }) => {
    const currentUser = useSelector(s => s.user.currentUser);
    const dispatch = useDispatch();
    const { loading, error, ready, request } = useRequest();

    const { contactPreference } = currentUser?.attributes?.profile?.publicData;

    const handleSubmit = async values => {
        const params = {
            publicData: {
                contactPreference: values?.contactPreference,
            },
        };

        await request(async () => await dispatch(updateUserProfileInfo(params)));
        onClose();
    };

    return (
        <ModalPortal id="ContactPreferenceModal" isOpen={isOpen} onClose={onClose}>
            <FinalForm
                onSubmit={values => {
                    handleSubmit(values);
                }}
                initialValues={{ contactPreference: contactPreference || contactOptions[0]?.value }}
                render={({ handleSubmit, values, form }) => (
                    <Form onSubmit={handleSubmit}>
                        <h3 className={css.header}>Kontaktpräferenz</h3>
                        <p className={css.description}>
                            Wähle aus, über welchen Kanal Du bevorzugt kontaktiert werden möchtest.
                        </p>

                        {contactOptions.map(option => (
                            <FieldRadioButton
                                key={option.key}
                                form={form}
                                id={`contactPreference-${option.key}`}
                                name="contactPreference"
                                label={option.label}
                                value={option.key}
                            />
                        ))}

                        <footer className={css.footer}>
                            <div className={css.delimiter} />
                            <p className={css.notification}>
                                Mitglieder sehen deine Präferenz, wenn Du deine <br /> Mobilnummer
                                in einer Konversation teilst.
                            </p>
                            {error && <p className={css.error}>{error}</p>}
                            <Button
                                type="submit"
                                disabled={!values?.contactPreference}
                                inProgress={loading}
                                ready={ready}
                            >
                                Hinzufügen
                            </Button>
                        </footer>
                    </Form>
                )}
            />
        </ModalPortal>
    );
};

export default ContactPreferenceModal;
